import React, { useState, useEffect } from 'react';
import { getProjects } from '../services/api';
import ProjectCard from '../components/ProjectCard';
import './Projects.css';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [technologies, setTechnologies] = useState([]);
  const [selectedTech, setSelectedTech] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await getProjects();
        setProjects(response.data);
        setFilteredProjects(response.data);
        
        // Extract unique technologies
        const techSet = new Set();
        response.data.forEach(project => {
          project.tech_list.forEach(tech => techSet.add(tech));
        });
        setTechnologies(Array.from(techSet).sort());
      } catch (error) {
        console.error('Error fetching projects:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  useEffect(() => {
    if (selectedTech === 'all') {
      setFilteredProjects(projects);
    } else {
      const filtered = projects.filter(project =>
        project.tech_list.includes(selectedTech)
      );
      setFilteredProjects(filtered);
    }
  }, [selectedTech, projects]);

  if (loading) {
    return <div className="loading">Loading projects...</div>;
  }

  return (
    <div className="projects-page">
      <div className="page-header">
        <h1>My Projects</h1>
        <p>Explore my latest work and personal projects</p>
      </div>

      <div className="filter-section">
        <div className="filter-container">
          <button
            className={`filter-btn ${selectedTech === 'all' ? 'active' : ''}`}
            onClick={() => setSelectedTech('all')}
          >
            All
          </button>
          {technologies.map(tech => (
            <button
              key={tech}
              className={`filter-btn ${selectedTech === tech ? 'active' : ''}`}
              onClick={() => setSelectedTech(tech)}
            >
              {tech}
            </button>
          ))}
        </div>
      </div>

      <div className="projects-container">
        {filteredProjects.length > 0 ? (
          <div className="projects-grid">
            {filteredProjects.map((project, index) => (
              <ProjectCard key={project.id} project={project} delay={index * 100} />
            ))}
          </div>
        ) : (
          <div className="no-projects">
            <p>No projects found with the selected technology.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;